const KEY = 'kkt_appearance';

export function readAppearance() {
  try {
    const value = localStorage.getItem(KEY);
    if (value === 'dark' || value === 'light') return value;
  } catch {
    /* ignore */
  }
  return 'light';
}

export function applyAppearance(theme) {
  const next = theme === 'dark' ? 'dark' : 'light';
  if (typeof document !== 'undefined') {
    const root = document.documentElement;
    root.setAttribute('data-appearance', next);
    root.style.colorScheme = next;
    const themeColor = document.querySelector('meta[name="theme-color"]');
    if (themeColor) {
      themeColor.setAttribute('content', next === 'dark' ? '#161b17' : '#f4faf2');
    }
    const scheme = document.querySelector('meta[name="color-scheme"]');
    if (scheme) {
      scheme.setAttribute('content', next);
    }
  }
  try {
    localStorage.setItem(KEY, next);
  } catch {
    /* ignore */
  }
  return next;
}

export function appearanceFromUser(user) {
  const fromUser = user?.settings?.theme;
  if (fromUser === 'dark' || fromUser === 'light') return fromUser;
  return readAppearance();
}

if (typeof document !== 'undefined') {
  applyAppearance(readAppearance());
}
